<template>
    <button class="btn btn-outline-success btn-sm rounded-0" @click="modal = !modal">
        <img src="../../../assets/pen-to-square.svg" width="15" >
    </button>
    <div v-if="modal" class="modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Editar</h5>
                <button @click="modal = !modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <!-- <pre>
                    {{v_nics}}
                </pre> -->
                <div class="form-floating mb-3">
                    <input v-model="categ.title" type="text" class="form-control">
                    <label>Título</label>
                </div>
                <div class="form-floating mb-3">
                    <textarea style="height:185px;" v-model="categ.description" type="text" class="form-control"></textarea>
                    <label>Descripción</label>
                </div>
                <div class="row">
                    <div class="col">
                        <photo-component :url="v_url_photo" :photolaravel="categ.photo"></photo-component>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <input type="radio" id="uno" value="es" v-model="categ.lang" class="mx-2">
                                <label for="uno">ES</label>
                                <br>
                                <input type="radio" id="Dos" value="en" v-model="categ.lang" class="mx-2">
                                <label for="Dos">EN</label>
                            </div>
                            <div class="col">
                                <label for="">Habilitado:</label>
                                <span class="form-switch">
                                    <input 
                                    class="form-check-input"
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="categ.enabled" 
                                    >
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-6">
                        Tipo:
                        
                        <v-select v-model="categ.type" :options="[
                            {code: 'food', name: 'Alimento'},
                            {code: 'drink', name: 'Bebida'}
                        ]" :reduce="country => country.code" label="name" />
                    </div>
                    <div class="col-6">
                        <div class="form-floating mb-3">
                            <input v-model="categ.position" type="number" class="form-control">
                            <label>Posición</label>
                        </div>
                    </div>
                    <div class="col-6">
                        <label for="">Menu:</label>
                        <span class="form-switch">
                            <input 
                            class="form-check-input"
                            type="checkbox"
                            true-value="1"
                            false-value="0"
                            v-model="categ.menu" 
                            >
                        </span>
                    </div>
                    <div class="col-6">
                        NIC:
                        <v-select v-model="categ.nic_id" :options="v_nics" :reduce="(option) => option.id" label="title"></v-select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button @click="modal = !modal" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button @click="save_category" type="button" class="btn btn-primary">Guardar cambios</button>
            </div>
            </div>
        </div>
    </div>

</template>
<script>

import { ref,computed, watch, onUpdated } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification'
import axios from 'axios'

import photoComponent from '../photos/photoComponent.vue'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css';

export default{
components:{photoComponent,vSelect,},
props:['category'],
setup(props){
    const store = useStore();
    const toast = useToast();
    const categ = ref({
        title:null,
        description:null,
        photo:null,
        lang:null,
        enabled:null,
        type:null,
        position:null,
        menu:null,
        nic_id:null,
    });
    const modal = ref(false);
    const v_user = computed(()=>store.state.login.v_user)
    const v_nics = computed(()=>store.state.nic.v_nics)

    watch(modal, (newName, oldName) => {
        // Haz algo (side effects) 👁
        if (newName){
            store.dispatch('nic/v_actions_nics')
            
        }
        console.log(newName,oldName)
    });

    const save_category = () =>{
        categ.value.photo = computed(()=>store.state.v_photo)
        let config = {
                headers: {
                'Authorization': 'Bearer ' + v_user.value.accessToken,
                'Accept':'application/json'
                }
            }        
            axios.put(store.state.v_url_global+'/categories/'+props.category.id,categ.value,config)
            .then(()=>{
                toast.success('actualizado');
                store.dispatch('v_action_categories');
            })
            .catch(()=>console.log('bad consult'))
    }


    onUpdated(()=>{
        categ.value = props.category;
    })

    return{
        save_category,
        v_nics,
        v_user,
        modal,
        categ,
        v_url_photo:computed(()=>store.state.v_url_photo),
    }
}
}
</script>